import type React from 'react';
import classnames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUpRightFromSquare } from '@fortawesome/pro-light-svg-icons/faArrowUpRightFromSquare';

import { Text, TextType } from 'ui-components/components/text';

import HelpArticleLink from '../../../../components/help-article-link';
import { linkIDs } from '../../../../services/link-service/links';
import { SettingsPageTitle } from '../../components/settings-page-title/settings-page-title';
import commonStyles from '../../settings-page.module.less';
import { AutomationRulesOrderImportContent, type AutomationRulesOrderImportContentProps } from './automation-rules-order-import-content';
import messages from '../messages';
import style from '../style.module.less';

export const AutomationRulesLegacyLayout: React.FC<AutomationRulesOrderImportContentProps> = (props) => (
  <div className={commonStyles.content}>
    <SettingsPageTitle value={messages.header} />
    <div className={classnames(style['page-description'], style.legacy)}>
      <Text className={style['page-description-text']} textType={TextType.Description} value={messages.subheader} />
      <HelpArticleLink articleId={linkIDs.CreateAutomationRules}>
        <FormattedMessage {...messages.learnMoreAboutAutomationRules} />
        <FontAwesomeIcon className={style['external-link-icon']} icon={faArrowUpRightFromSquare} />
      </HelpArticleLink>
    </div>
    <AutomationRulesOrderImportContent {...props} />
  </div>
);
